function movePersonElement(isPresent, isChecked, memberId, declarationText, declarationComment, htmlBlock=null) {
    let status;
    if (isChecked) {
        status = isPresent ? "checked-present" : "checked-absent";
    } else {
        status = isPresent ? "declared-present" : "declared-absent";
    }

    const $listToAddElement = $('#' + status);
    let $userRow = $('#member_' + memberId);    
    
    // Get the member name for sorting
    const $nameWrap = $userRow.find('.event-check-list-username');
    const memberName = $nameWrap.find('b, .member-name, .attendance-member-name').first().text().trim() ||
                      $userRow.find('strong').first().text().trim();
    
    // Extract surname for sorting (assume "FirstName LastName" format)
    const surname = memberName.split(' ').pop().toLowerCase();
    
    $userRow.detach();

    if (isChecked) {
        $nameWrap.empty().append($('<b>').text(memberName));

        $userRow.find('.event-check-list-user-declaration').addClass('d-none');
        $userRow.find('option[value="remove"]').removeClass('d-none');
        $userRow.find('.event-check-list-declaration-comment').addClass('d-none');
    } else {
        // If we remove check, the whole section with modal window etc. needs to be rebuilt from html sent with ajax 
        if (htmlBlock) {
            $userRow.find('.event-check-list-username').html(htmlBlock);
        } else {
            $userRow.find('.event-check-list-user-declaration').text(declarationText).removeClass('d-none');
            $userRow.find('.event-check-list-declaration-comment').text(declarationComment).removeClass('d-none');
        }
        $userRow.find('option[value="remove"]').addClass('d-none');
        $userRow.find('.event-check-list-select').val('').trigger('blur');
    }
    
    // Insert in alphabetical order by surname
    const $existingItems = $listToAddElement.find('li');
    let inserted = false;
    
    $existingItems.each(function() {
        const $existingItem = $(this);
        const $existingNameWrap = $existingItem.find('.event-check-list-username');
        const existingMemberName = $existingNameWrap.find('b, .member-name, .attendance-member-name').first().text().trim() ||
                                  $existingItem.find('strong').first().text().trim();
        const existingSurname = existingMemberName.split(' ').pop().toLowerCase();
        
        if (surname < existingSurname) {
            $userRow.insertBefore($existingItem);
            inserted = true;
            return false; // Break the loop
        }
    });
    
    // If not inserted yet, append to the end
    if (!inserted) {
        $userRow.appendTo($listToAddElement);
    }
}


function sendAjaxRequest(requestData, url, callback) {
    const xhr = new XMLHttpRequest();

    var csrftoken = $.cookie('csrftoken'); // Get CSRFToken from cookie

    xhr.open("POST", url, true);
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    xhr.setRequestHeader('X-CSRFToken', csrftoken);

    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
            callback(JSON.parse(xhr.responseText));
        }
    };

    xhr.send(JSON.stringify(requestData));
}


document.addEventListener("DOMContentLoaded", function () {
    const checkListSelect = document.querySelectorAll(".event-check-list-select");
    checkListSelect.forEach(function (select) {
        select.addEventListener("change", function (e) {

            const ensembleSlug = select.getAttribute("data-ensemble-slug");
            const eventSlug = select.getAttribute("data-event-slug");
            const memberId = select.getAttribute("data-member-id");

            if(select.value === 'remove'){

                const url = `/api/event/${ensembleSlug}/${eventSlug}/${memberId}/check-list/delete`;

                sendAjaxRequest({}, url, (responseData) => {
                    movePersonElement(
                        responseData.isPresent,
                        false,
                        memberId,
                        null,
                        null,
                        responseData.html
                    );
                });

            } else {
                // Check
                const requestData = {
                    name: select.getAttribute("data-name"),
                    id: select.value,
                    memberId: memberId,
                };

                const url = `/api/event/${ensembleSlug}/${eventSlug}/check-list/check`;

                sendAjaxRequest(requestData, url, (responseData)=>{
                    movePersonElement(
                        document.querySelector('option[value="'+ select.value + '"]').getAttribute("data-is_present") === "True",
                        true,
                        requestData.memberId,
                        true
                    );
                });
            }
        });
    });
});

